import { useId } from "react";

interface FacetAutogenerateCountdownRingProps {
  remaining: number;
  total: number;
  holdLabel: string;
}

const RING_SIZE = 148;
const STROKE = 7;

export default function FacetAutogenerateCountdownRing({
  remaining,
  total,
  holdLabel,
}: FacetAutogenerateCountdownRingProps) {
  const gradientId = useId();
  const radius = (RING_SIZE - STROKE) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = total > 0 ? (total - remaining) / total : 1;
  const dashOffset = circumference * (1 - progress);
  const center = RING_SIZE / 2;

  return (
    <div className="relative" style={{ width: RING_SIZE, height: RING_SIZE }}>
      <svg
        width={RING_SIZE}
        height={RING_SIZE}
        className="-rotate-90"
        aria-hidden
      >
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#2563eb" />
            <stop offset="100%" stopColor="#c026d3" />
          </linearGradient>
        </defs>
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#e8ecf4"
          strokeWidth={STROKE}
        />
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          className="transition-[stroke-dashoffset] duration-1000 ease-linear"
        />
      </svg>

      <div className="absolute inset-0 flex flex-col items-center justify-center">
        {remaining > 0 ? (
          <>
            <span className="text-4xl font-bold tabular-nums leading-none text-[#111827]">
              {remaining}
            </span>
            <span className="mt-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-gray-400">
              sec left
            </span>
          </>
        ) : (
          <span className="max-w-[88px] text-center text-sm font-semibold leading-tight text-[#2563eb]">
            {holdLabel}
          </span>
        )}
      </div>
    </div>
  );
}
